<template>
  <div id="GuestDialog_main">
    <el-dialog
      id="guestDialog"
      title="目前訪客列表"
      :visible.sync="dialogVisible"
      width="70%"
      @close="closeDialog"
    >
      <div slot="title">
        <span class="el-dialog__title">目前訪客列表</span>
        <span
          class="subTitle"
          @click="gotoPlusGuestReservation"
        >訪客管理列表</span>
      </div>
      <el-table
        :data="listData"
        ety-text="目前無訪客紀錄"
        tooltip-effect="dark"
        :cell-class-name="cellStyle"
      >
        <el-table-column
          type="index"
          width="50"
          label="#"
        />
        <el-table-column
          prop="ArrivedInfo.CreateAt"
          label="抵達時間"
          min-width="80"
        />
        <el-table-column
          label="拜訪時間"
          min-width="80"
        >
          <template
            v-if="scope.row.ArrivedInfo"
            slot-scope="scope"
          >
            <span v-text="diffDay(scope.row.ArrivedInfo.CreateAt)" />
          </template>
        </el-table-column>
        <el-table-column
          prop="TabletNote"
          label="拜訪戶別"
        />
        <el-table-column
          prop="GuestName"
          label="訪客／廠商名稱"
        />
        <el-table-column
          label="門禁卡借用"
          width="100"
          align="center"
        >
          <template
            v-if="scope.row.ArrivedInfo"
            slot-scope="scope"
          >
            <el-tooltip
              v-if="scope.row.ArrivedInfo.CarrierCode !== ''"
              placement="top"
              content="尚未歸還"
            >
              <i
                class="icon-give-card"
                aria-hidden="true"
              />
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          label="詳細資訊"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <el-tooltip
              v-if="( scope.row.LicensePlateNumber !== null && scope.row.LicensePlateNumber !== '') ||
                (scope.row.Remark !== null && scope.row.Remark !== '') ||
                (scope.row.ArrivedInfo.IdCardId !== null && scope.row.ArrivedInfo.IdCardId !== '')"
              placement="top"
            >
              <div slot="content">
                <p>押件：{{ getIdCard(scope.row) || '無' }}</p>
                <p>車牌：{{ scope.row.LicensePlateNumber || '無' }}</p>
                <p>備註：{{ scope.row.Remark || '無' }}</p>
              </div>
              <i
                class="icon-info info"
                aria-hidden="true"
              />
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="85"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.Id"
              size="mini"
              type="primary"
              plain
              @click="guestLeave(scope.row.Id)"
            >
              離開
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <TableLoading :is-loading="loading" />
    </el-dialog>
  </div>
</template>
<script>
import TableLoading from '@/components/TableLoading'
export default {
  components: {
    TableLoading
  },
  props: {
  },
  data () {
    return {
      dialogVisible: false,
      listData: [],
      idCardList: [], // 押件清單
      offset: 0,
      scrollEnd: false,
      loading: false,
      getJWTtokenLoop: null,
      canClickButton: true // 防止連點button參數
    }
  },
  watch: {
    $route (to, from) {
      if (to !== from) { this.closeDialog() }
    }
  },
  methods: {
    async openDialog () {
      this.dialogVisible = true
      this.listData = []
      await this.getIdCardList().catch(err => { console.log(err) })
      this.init()
      document.getElementById('guestDialog').addEventListener('scroll', this.autoShow, true)
    },
    closeDialog () {
      this.dialogVisible = false
      document.getElementById('guestDialog').removeEventListener('scroll', this.autoShow, true)
      clearInterval(this.getJWTtokenLoop)
      this.getJWTtokenLoop = null
    },
    async init () {
      const res = await this.getJWTToken()
      console.log(res)
      if (res === 'error') { return }
      if (this.$router.currentRoute.name !== 'PlusGuestReservation' && this.$router.currentRoute.name !== 'GuestRecord') {
        this.getJWTtokenLoop = setInterval(() => {
          this.getJWTToken()
        }, 5 * 60 * 1000) // 5分鐘
      }
      this.listData = []
      this.offset = 0
      await this.getList()
      // 當螢幕過大時，彈窗需用資料撐開至可滑動狀態
      let count = 1
      if (document.getElementById('guestDialog').scrollHeight > 864) {
        count = Math.ceil(document.getElementById('guestDialog').scrollHeight / 864) - 1
        for (let i = 0; i < count; i++) {
          this.offset += 10
          this.getList()
        }
      }
    },
    async getJWTToken () {
      const res = await this.$getJWTToken()
      return new Promise((resolve, reject) => {
        if (res && res.status === 200) {
          resolve('true')
        } else {
          console.log(res.status)
          if (res.status === 401 && this.$router.currentRoute.name !== 'login') {
            this.dialogVisible = false
            this.closeDialog()
            this.$alert('登入過期或驗證失敗，請重新登入', '警告', {
              confirmButtonText: '確定',
              type: 'warning',
              showClose: false,
              roundButton: true,
              closeOnClickModal: false
            }).then(() => {
              this.$router.push({ name: 'LoginMain' })
            })
            resolve('error')
          } else if (res.status >= 400) {
            this.dialogVisible = false
            this.closeDialog()
            this.$alert('目前系統連線異常，建議重新整理後，請稍候再重新試一次。如有多次嘗試仍無法解決，請致電智生活客服中心為您處理。', '警告', {
              confirmButtonText: '確定',
              type: 'warning',
              showClose: false
            })
            resolve('error')
          }
        }
      })
    },
    // 取得列表內容
    getList () {
      return new Promise((resolve, reject) => {
        this.loading = true
        const requestData = {
          Offset: this.offset,
          MaxCount: 10
        }
        setTimeout(() => {
          apiGuest.GuestDialog.GetGuestArrivedData(
            requestData
          ).then(res => {
            if (res.data.length !== 0) {
              this.listData = this.offset === 0 ? [] : this.listData
              res.data.forEach(val => {
                val.CreateAt = this.$newFormatDate(val.CreateAt)
                if (val.ArrivedInfo) { val.ArrivedInfo.CreateAt = this.$newFormatDate(val.ArrivedInfo.CreateAt).slice(0, 16) }
                this.listData.push(val)
              })
              if (this.listData.length > 10) { document.getElementById('guestDialog').scrollTo(0, document.getElementById('guestDialog').scrollHeight - (document.getElementById('guestDialog').clientHeight * 1.2)) }
            }
            this.loading = false
            this.scrollEnd = res.data.length < 10
            resolve()
          }).catch(err => {
            console.log('錯誤訊息：', err.response)
            if (err.response.status === 401) {
              this.$alert('登入過期或驗證失敗，請重新登入', '警告', {
                confirmButtonText: '確定',
                type: 'warning',
                showClose: false,
                roundButton: true,
                closeOnClickModal: false
              }).then(() => {
                this.dialogVisible = false
                this.closeDialog()
                this.$router.push({ name: 'LoginMain' })
              })
            } else if (err.response.status >= 400) {
              this.$alert('目前系統連線異常，建議重新整理後，請稍候再重新試一次。如有多次嘗試仍無法解決，請致電智生活客服中心為您處理。', '警告', {
                confirmButtonText: '確定',
                type: 'warning',
                showClose: false
              })
              this.dialogVisible = false
              this.closeDialog()
            }
            reject(err)
          })
        }, 1000)
      })
    },
    // 取得押件清單
    getIdCardList () {
      return new Promise((resolve, reject) => {
        apiGuest.PlusGuestReservation.GetIdCard().then((res) => {
          if (res.status === 200) { this.idCardList = res.data }
          resolve()
        }).catch((err) => {
          console.log('錯誤訊息：', err.response)
          reject(err)
        })
      })
    },
    // 輸出押件顯示文字
    getIdCard (row) {
      let idCard = ''
      this.idCardList.forEach(item => {
        if (item.Id === row.ArrivedInfo.IdCardId) { idCard = item.Name }
      })
      return idCard
    },
    // 離開
    guestLeave (id) {
      if (this.canClickButton) {
        this.canClickButton = false
        const queryPath = {
          id
        }
        const config = {
          'content-type': 'application/json-patch+json'
        }
        apiGuest.GuestRecord.PostLeaved(
          queryPath,
          config
        ).then(res => {
          if (res.status === 200) {
            this.init()
            this.$message({
              message: '訪客離開成功',
              type: 'success'
            })
          }
        }).catch(err => {
          if (err.response.status === 400) {
            this.$message({
              message: '訪客已離開！',
              type: 'warning'
            })
            this.init()
          }
          console.log('錯誤訊息：', err.response)
        })
        setTimeout(() => {
          this.canClickButton = true
        }, 1000)
      }
    },
    // 下拉到底自動載入
    autoShow () {
      const scrollTop = document.getElementById('guestDialog').scrollTop
      const scrollHeight = document.getElementById('guestDialog').scrollHeight
      const clientHeight = document.getElementById('guestDialog').clientHeight
      if ((scrollTop + clientHeight >= scrollHeight - 20) && !this.loading) {
        if (!this.scrollEnd) {
          this.offset += 10
          this.getList()
        }
      }
    },
    gotoPlusGuestReservation () {
      this.$router.push({ name: 'PlusGuestReservation', params: { guestId: 'List' } })
      this.closeDialog()
    },
    // 計算拜訪時間
    diffDay (startDay) {
      const startDate = new Date(startDay)
      const endDate = new Date()
      let diffDay
      const min = parseInt(Math.abs(startDate - endDate) / 1000 / 60)
      if (min < 60) {
        diffDay = min + '分鐘'
      }
      if (min >= 60) {
        const hr = parseInt(Math.abs(startDate - endDate) / 1000 / 60 / 60)
        diffDay = hr + '小時'
        if (hr >= 24) {
          const day = parseInt(Math.abs(startDate - endDate) / 1000 / 60 / 60 / 24)
          diffDay = day + '天'
        }
      }
      return diffDay
    },
    // table 樣式
    cellStyle ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 5) { return 'barcodeIcon' }
    }
  }
}
</script>
<style lang="sass" scoped>
#GuestDialog_main
  ::v-deep .el-dialog
    +basicDialog
    min-width: 860px
    .el-dialog__header
      .subTitle
        font-weight: normal
        margin-left: 9px
        text-decoration: underline
        font-size: 16px
        color: $mainColorDark
        cursor: pointer
    .el-dialog__body
      padding: 12px 8px
  ::v-deep .el-table
    +basicTable
    font-size: 15px
    .icon-give-card
      font-size: 28px
      color: $dangerColor
    .info
      font-size: 22px
      color: #999
    .barcodeIcon
      padding-top: 5px
      padding-bottom: 0

</style>
